import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDamagedPointsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1378 15.6211H14.8678C13.0078 15.6211 12.5878 16.5511 12.3578 17.7011L11.5078 21.7511H23.5078L22.6578 17.7011C22.4078 16.5511 21.9978 15.6211 20.1378 15.6211Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9882 28.3622C25.0682 29.2422 24.3682 30.0022 23.4682 30.0022H22.0582C21.2482 30.0022 21.1382 29.6522 20.9882 29.2322L20.8382 28.7822C20.6282 28.1722 20.4882 27.7522 19.4082 27.7522H15.5682C14.4882 27.7522 14.3282 28.2222 14.1382 28.7822L13.9882 29.2322C13.8482 29.6622 13.7382 30.0022 12.9182 30.0022H11.5082C10.6082 30.0022 9.89817 29.2422 9.98817 28.3622L10.4082 23.7922C10.5182 22.6622 10.7282 21.7422 12.6982 21.7422H22.2682C24.2382 21.7422 24.4482 22.6622 24.5582 23.7922L24.9882 28.3622Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 19.5H10.75",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.25 19.5H23.5",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 24.75H15.25",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.75 24.75H22",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12L22 8L24.5 12L27.5 9.5L27 13.5L30 14L27.5 17L31 18L28.5 19.5",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgDamagedPointsIcon;
